import jsPDF, { jsPDFAPI } from "jspdf";
import { A3MM, BasePDFNode, getYoga, RectPDFNode, TextPDFNode } from "./BasePDFNode";
import { RangedKanaal, RangedKanaalAssign } from "../props/PropTypes";
import { HdwLayout, Kaart, Rack } from "../kanaal/hdw-config/HdwSysteem";
import { IOKlemPDFNode } from "./KaartPDFNode";
import { DipSwitch } from "./KaartPartsNodes";
import { PageCardNode } from "./PageCardNode";



export class SC900MainRackNode extends BasePDFNode {
    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public rack: Rack) {
        super(pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        }, getYoga().Node.create());
    }

    public pageCard: PageCardNode | undefined;


    public init(): void {
        for (let kaart of this.rack.kaarten) {
            this.addChild2(new SC900IONode(this.pdf, this.kanaalMap, kaart));
        }
        super.init();
    }

    public render(): void {
        for (let c of this.children) {
            this.pdf.addPage("a3", "p");
            c.layout.calculateLayout(A3MM.width, A3MM.height);
            if (this.pageCard == undefined) {
                let l = c.layout.getComputedLayout();
                let topLeft = c.getTopLeft();
                this.pdf.rect(topLeft.x, topLeft.y, l.width, l.height);
            } else {
                this.pageCard.render();
            }
            c.render();
        }
    }
}


export class SC900IONode extends RectPDFNode {
    constructor(public pdf: jsPDF, public kanaalMap: Record<string, Array<Array<RangedKanaalAssign>>>, public kaart: Kaart) {
        super(pdf, {
            flexDirection: 'column',
            flexGrow: 1,
            margin: 2,
            padding: 2,

        }, getYoga().Node.create());

    }

    public init(): void {

        let top = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'row',
            justifyContent: "space-between",
            marginBottom: 2
        }));
        let title = top.addChild2(new TextPDFNode(this.pdf, {
            fontSize: 12
        }));
        title.text = `${this.kaart.type.label} ${this.kaart.number}`;
        top.addChild2(new DipSwitch(this.pdf, this.kaart.dipSwitch, this.kaart.type.maxDipSwitchBits));

        let klemContainer = this.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: 'row',
            justifyContent: "space-between",
            flexWrap: "wrap",
            flexGrow: 1,
            rowGap: 2,
            columnGap: 1
            // fillColor: '#E0E000',
            // borderColor: '#E00000'

        }));


        let hdwLayout = this.kaart.getHdwLayout();
        let hdwLayouts: HdwLayout[][] = [];
        let current: HdwLayout[] = [];
        let splitLength = 10;
        for (let l of hdwLayout) {
            if (current.length == splitLength) {
                hdwLayouts.push(current);
                current = [];
            }
            current.push(l);
        }
        if (current.length > 0) {
            hdwLayouts.push(current);
        }

        for (let i = 0; i < hdwLayouts.length; i++) {
            let hdwLayoutPart = hdwLayouts[i];
            let wrapper = klemContainer.addChild2(new RectPDFNode(this.pdf, {
                padding: 1,
                paddingBottom: 2
            }));
            let ioKlem = new IOKlemPDFNode(this.pdf, this.kanaalMap, hdwLayoutPart);
            ioKlem.style.maxWidth = 91;
            ioKlem.style.width = 91;
            wrapper.addChild2(ioKlem);
        }


        super.init();
    }

}